import * as React from "react";
import type { SVGProps } from "react";
const SvgWorldWithLeaf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.444 20.315a10 10 0 0 0 4.94 1.666 1.003 1.003 0 0 0 .285.013c.11.004.22.006.331.006a1 1 0 0 0 .13-1.991A15.91 15.91 0 0 1 9.477 16H11a1 1 0 0 0 0-2H9.092a15.91 15.91 0 0 1-.001-4h3.8c.078.662.115 1.33.109 2a1 1 0 0 0 2 0 17.98 17.98 0 0 0-.097-2h3.843A8 8 0 0 1 19 12a1 1 0 0 0 2 0 10 10 0 1 0-15.556 8.315ZM14.58 8h3.348a8 8 0 0 0-4.571-3.645c.537 1.17.947 2.392 1.223 3.645ZM11.02 4.173A15.91 15.91 0 0 0 9.475 8h3.05a15.937 15.937 0 0 0-1.504-3.827ZM6.555 18.652a8 8 0 0 0 2.152 1.012A17.921 17.921 0 0 1 7.437 16H4.072a8 8 0 0 0 2.483 2.652Zm.43-6.57c.003.643.04 1.283.112 1.918H3.254a8 8 0 0 1 0-4h3.842a17.92 17.92 0 0 0-.111 2.083ZM7.435 8c.29-1.261.715-2.49 1.27-3.664A8 8 0 0 0 4.072 8h3.364Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.18 21.69h-.724a4 4 0 0 0-.036.43 1 1 0 0 1-.99.88h-.11a1 1 0 0 1-.88-1.1c.023-.391.083-.777.18-1.154A3.82 3.82 0 0 1 13 18.5c0-1.85.82-4.95 6.25-4.95H21a1 1 0 0 1 1 1v.88c-.3 5.18-3.33 6.26-5.82 6.26Zm1.72-3.15a4 4 0 0 0-1.562 1.148c1.602-.032 3.39-.595 3.652-4.138h-.75c-3.515 0-4.162 1.43-4.24 2.65a6 6 0 0 1 2.09-1.48 1 1 0 1 1 .81 1.82Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWorldWithLeaf;
